<cc-input-error *ngIf="error"
                [form]="form"
                [inputName]="inputName"
                [inputIndex]="inputIndex"
                [error]="error.error"
                [text]="error.text"></cc-input-error>
